import { render } from "./ListadoRetiros.vue?vue&type=template&id=0b44a887"
import script from "./ListadoRetiros.vue?vue&type=script&lang=js"
export * from "./ListadoRetiros.vue?vue&type=script&lang=js"

import "./ListadoRetiros.vue?vue&type=style&index=0&id=0b44a887&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__